import { 
  Component,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  ViewChild,
  ElementRef } from '@angular/core';
import { CarritoService } from '../../services/carrito.service';
import { ModalMensajeComponent } from '../general/modal-mensaje/modal-mensaje.component';
import { GLOBAL } from '../../services/global';
import { ActivatedRoute, Router } from "@angular/router";
import { MapaService } from '../../services/mapa.service';
import { LoginService } from 'src/app/services/login.service';
import { User } from 'src/app/models/user';
import { ModalConfirmComponent } from '../general/modal-confirm/modal-confirm.component';
import { PedidoService } from 'src/app/services/pedido.service';
import { RedsysService } from 'src/app/services/redsys.service';

@Component({
  selector: 'app-carrito',
  templateUrl: './carrito.component.html',
  styleUrls: ['./carrito.component.css']
})
export class CarritoComponent implements OnInit {

  carrito: any;
  logistica: any;
  refModalMensaje: any = {};
  url: string;
  total: number;
  totalProductos: number;
  showDetallesPedido: boolean = true;
  gastoEnvio: number=-1;
  gastoEnvioMarcar: any = [];
  pesoTotalPedido: number=0;
  totalPedido: number=0;
  user: any;
  provincias: any[];
  municipios: any[];
  sobrepeso: boolean = false;
  rangosSeleccionado: any = 2;
  filteredMunicipios: any[];
  valueProvincia: any = null;
  valueMunicipio: any = null;
  totalesMarcas: any = [];
  infoDescuentos: any = [];
  descuentoTotal: number=0;
  direccionEntrega: any = {
    dni_cif: "",
    nombre: "",
    apellidos: "",
    direccion: "",
    codigoPostal: "",
    telefono: "",
    email: "",
    provincia: null,
    municipio: null,
    politicas: false,
    novedades_registro: false
  };
  diaSemanaHoy: any = 0;
  diasSemana = [
    'lunes',
    'martes',
    'miercoles',
    "jueves",
    "viernes",
    "sabado",
    "domingo"
  ];

  municipioValido: boolean = null;

  isScrolled: boolean = false;
  private scrollThreshold: number = 50;


  @ViewChild('modalMensaje', { read: ViewContainerRef, static: false }) entry: ViewContainerRef;

  @ViewChild('taPreferenciasEntrega', { read: ElementRef, static: false }) taPreferenciasEntrega: ElementRef;

  constructor(
    private carritoService: CarritoService,
    private resolver: ComponentFactoryResolver,
    private router: Router,
    private mapService: MapaService,
    private lService: LoginService,
    private pedidoService: PedidoService,
    private redsysService: RedsysService
  ) {
    this.url = GLOBAL.url;
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem("user"));

    this.getDatosFormulario();
    this.getDatosCarrito();

    const hoy = new Date();
    this.diaSemanaHoy = hoy.getDay() - 1;

    if (this.diaSemanaHoy < 0) {
      this.diaSemanaHoy = 6;
    }
  }

  ngOnDestroy(): void {
    this.guardarDireccionEntregaEnStorage();
  }

  guardarDireccionEntregaEnStorage() {
    localStorage.setItem('direccionEntregaCarrito', JSON.stringify(this.direccionEntrega));
  }

  ngAfterViewInit() {
    // Forzar scroll al inicio después de que la vista se haya inicializado
    window.scrollTo(0, 0);
  }

  onScroll(event): void {
      let scrollTop = event.target.scrollTop; 
      console.log(scrollTop); // Obtener la posición de desplazamiento actual
  
    this.isScrolled = scrollTop > this.scrollThreshold;
  }

  autoResize(textarea: HTMLTextAreaElement): void {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  getDatosCarrito() {
    const carrito = JSON.parse(localStorage.getItem('carrito'));

    this.carritoService.getDatosCarrito(carrito).subscribe(result => {
      if (result.result == "ok") {
        this.carrito = result.carrito; 
        this.logistica = result.logistica;

        for (let itemMarca in this.carrito) {
          this.carrito[itemMarca].fabricante.horario_envio=null;
          this.carrito[itemMarca].fabricante.responsable_envio="";
          this.carrito[itemMarca].fabricante.hora_limite_recogida_empresa=this.carrito[itemMarca].fabricante.hora_limite_recogida;
          this.carrito[itemMarca].fabricante.dias_semana_sin_recogida_empresa=this.carrito[itemMarca].fabricante.dias_semana_sin_recogida;

        }

        this.calcularTotal();
        this.calcularPesoTotalPedido();
        this.calcularGastoEnvio();
      } else {
        this.mostrarMensajeModal("Error", "Error al obtener los datos del carrito");
      }
    });


  }

  getVisualizarRango(id) {
   
    let horaLimiteRecogida = null;
    for (let itemMarca in this.carrito) {
      horaLimiteRecogida = this.carrito[itemMarca].fabricante.hora_limite_recogida;
    }

    let horaActual = new Date().getHours();
    let horaDesdeLimite = parseInt(horaLimiteRecogida.split(':')[0], 10);

    if(this.diaSemanaHoy==4 && horaLimiteRecogida != null){
      console.log("horaActual", horaActual);
      console.log("horaDesdeLimite", horaDesdeLimite);
      console.log("id", id);
      if((horaActual >= horaDesdeLimite) && id==3){
        console.log("entra en el if");
        this.rangosSeleccionado = 3;
        this.calcularGastoEnvio();
        return true;
      }else if((horaActual < horaDesdeLimite) && id!=3){
        console.log("entra en el else if");
        return true;
      }else{
        console.log("entra en el else");
        return false;
      }
    }else if(this.diaSemanaHoy==5 && horaLimiteRecogida != null){
      
      if((horaActual < horaDesdeLimite) && id==3){
        this.rangosSeleccionado = 3;
        this.calcularGastoEnvio();
        return true;
      }else if((horaActual >= horaDesdeLimite) && id!=3){
        return true;
      }else{
        return false;
      }
    }
    else if(id!=3){
      return true;
    }else{
      return false;
    }
  }

  calcularPesoTotalPedido() {
    this.pesoTotalPedido = 0;
    for (let itemMarca in this.carrito) {
      for (let producto of this.carrito[itemMarca].productos) {
        if(producto.precio.peso_unidad_venta !=null){
          this.pesoTotalPedido += producto.precio.peso_unidad_venta * producto.cantidad;
        }
      }
    }
  }

  eliminarProducto(index, keyvalue) {

    this.carrito[keyvalue].productos.splice(index, 1);

    if (this.carrito[keyvalue].productos.length == 0) {
      delete this.carrito[keyvalue];
    }

    const carritoOrigen = JSON.parse(localStorage.getItem('carrito'));
    carritoOrigen[keyvalue].splice(index, 1);

    if (carritoOrigen[keyvalue].length == 0) {
      delete carritoOrigen[keyvalue];
    }

    localStorage.setItem('carrito', JSON.stringify(carritoOrigen));

    if(Object.keys(carritoOrigen).length == 0){
      this.navegar('buscador');
    }else{
      this.calcularTotal();
      this.calcularPesoTotalPedido();
      this.calcularGastoEnvio();
    }

  }

  irAlProducto(slug) {

    this.router.navigate(['producto/' + slug]);
  }

  calcularTotal() {
    let total = 0;
    let totalProductos = 0;
    this.descuentoTotal = 0;
    for (const key in this.carrito) {
      if (this.carrito.hasOwnProperty(key)) {
        const marca = this.carrito[key];

        this.totalesMarcas[key] = {
          total: 0,
        };

        let indexProducto = 0;

        for (const producto of marca.productos) {
          if(producto.precio != null){
            total += producto.cantidad * producto.precio.precio;
            this.totalesMarcas[key].total += producto.cantidad * producto.precio.precio;
          }else{
            this.eliminarProducto(indexProducto, key);
          }
          indexProducto++;
          totalProductos++;
        }

      }
    }
    this.total = total;
    this.totalProductos = totalProductos;
  }

  calcularDescuentos(key) {
    let totalMarca=this.totalesMarcas[key];

    for(const descuento of this.carrito[key].fabricante.descuentos_pedido){
      if(totalMarca.total >= descuento.precio_desde){
        if(descuento.quitar_envio == 0){
          this.descuentoTotal += parseFloat(descuento.descuento);
        }else{
          this.descuentoTotal += parseFloat(this.gastoEnvioMarcar[key]);
        }
        break;
      }else{
        this.infoDescuentos[key] = {
          descuento: descuento.descuento,
          precio_desde: descuento.precio_desde,
          quitar_envio: descuento.quitar_envio
        }
      }
    }

    if(this.descuentoTotal > this.gastoEnvio){
      this.descuentoTotal = this.gastoEnvio;
    }

  }

  getEnviaZona() {
    for (let itemMarca in this.carrito) {
      if(this.carrito[itemMarca].fabricante.responsable_envio == null){
        return false;
      }
    }
    return true;
  }

  onClickPagar() {
    if(this.validarForm()){

      let model = {
        direccionEntrega: this.direccionEntrega,
        carrito: this.carrito,
        user_id: this.user==null ? null : this.user.id,
        gasto_envio: this.gastoEnvio,
        peso_pedido: this.pesoTotalPedido,
        total_productos: this.total,
        total_descuento_envio: this.descuentoTotal,
        total_pedido: this.totalPedido,
        rango_envio: this.rangosSeleccionado
      };

      
      this.pedidoService.crearPedido(model).subscribe(result => {
        if(result.result == "ok"){

          let novedadesRegistro = this.direccionEntrega.novedades_registro ? 1 : 0;
          
          this.redsysService.crearPago(result.pedido_id, novedadesRegistro).subscribe(result => {
            this.redirigirARedsys(result);
          });
        }else{
          this.mostrarMensajeModal("Error", "Se ha producido un error al crear el pedido.");
        }
      });
    }
  }

  private redirigirARedsys(data: any) { 
    const form = document.createElement('form'); 

    form.method = 'POST'; 
    form.action = 'https://sis-t.redsys.es:25443/sis/realizarPago'; // sandbox 
    ['Ds_SignatureVersion', 'Ds_MerchantParameters', 'Ds_Signature'].forEach(key => { 
      const input = document.createElement('input'); 
      input.type = 'hidden'; 
      input.name = key; 
      input.value = data[key]; 
      form.appendChild(input); 
    }); 
    
    document.body.appendChild(form); 
    form.submit(); 
  }

  validarForm() {

      let camposValidar = [
        "dni_cif",
        "nombre",
        "apellidos",
        "direccion",
        "codigoPostal",
        "telefono",
        "email",
        "municipio",
        "politicas"
        ];
      let nombreCampos = { 
        dni_cif: "DNI/CIF",
        nombre: "Nombre",
        apellidos: "Apellidos",
        direccion: "Dirección",
        codigoPostal: "Código Postal",
        telefono: "Teléfono",
        email: "Email",
        municipio: "Municipio",
        politicas: "Acepta las políticas de privacidad y condiciones de uso"
      };
      let mensaje = "Estos campos son obligatorios: ";
      let error = false;

      let validadoPrecioMinimoPedido = this.validarPrecioMinimoPedido();

      if(validadoPrecioMinimoPedido){
        if (this.direccionEntrega.municipio != null && ((this.direccionEntrega.municipio.provincia.id != null && this.direccionEntrega.municipio.provincia.id != "") && this.direccionEntrega.municipio.id == "")) {
          mensaje = "Si eliges una provincia tienes que elegir un municipio.";
          this.mostrarMensajeModal("Realizar Pago", mensaje);
          return false;
        } else {
          for (let i = 0; i < camposValidar.length; i++) {

            if(camposValidar[i] == "politicas"){
              if(this.user == null){
                
                if(this.direccionEntrega.politicas == false){
                  mensaje += nombreCampos[camposValidar[i]] + ",";
                  error = true;
                }
              }
            }
            else{
              
              if (this.direccionEntrega[camposValidar[i]] == undefined || this.direccionEntrega[camposValidar[i]] == "" || this.direccionEntrega[camposValidar[i]] == null) {
                mensaje += nombreCampos[camposValidar[i]] + ",";
                error = true;
              }
            }

          }
        }

        if (!error) {
          if(!this.sobrepeso){
            let validadoGastoEnvio = this.validarGastoEnvio();
            if(validadoGastoEnvio){
              return true;
            }
          }else{
            this.mostrarMensajeModal("Sobrepeso", "El peso total del pedido es mayor al peso máximo permitido para el rango de envio seleccionado.");
            return false;
          }

        } else {
          mensaje = mensaje.substring(0, (mensaje.length - 1));
          this.mostrarMensajeModal("Faltan datos", mensaje);
          return false;
        }
      }
  }

  validarPrecioMinimoPedido() {
    for (const key in this.carrito) {
      let totalMarca=0;
      if (this.carrito.hasOwnProperty(key)) {
        const marca = this.carrito[key];
        for (const producto of marca.productos) {
          totalMarca += producto.cantidad * producto.precio.precio;
        }
      }
     
      if(totalMarca < this.carrito[key].fabricante.precio_minimo_pedido){
        this.mostrarMensajeModalPedidoMinimo(this.carrito[key].fabricante);
        return false;
      }else{
        return true;
      }
    }
  }

  validarGastoEnvio() {
    if(this.gastoEnvio == -1){
      this.mostrarMensajeModalGastoEnvio();
      return false;
    }else{
      return true;
    }
  }

  mostrarMensajeModalGastoEnvio() {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalConfirmComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = "No se puede calcular gasto de envio.";
    this.refModalMensaje.instance.titulo = "Calcula tu gasto de envio";
    this.refModalMensaje.instance.showBotonCancelar = false;
    this.refModalMensaje.instance.showNotas = false;
    this.refModalMensaje.instance.botones = [
      {
        texto: "OK", accion: () => {
          this.refModalMensaje.instance.funCerrar();
        }
      }
    ];
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  mostrarMensajeModalPedidoMinimo(fabricante) {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalConfirmComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = "El pedido mínimo de esta marca es de "+ this.formatNumber(fabricante.precio_minimo_pedido) + "€";
    this.refModalMensaje.instance.titulo = "No alcanza el pedido mínimo";
    this.refModalMensaje.instance.showBotonCancelar = false;
    this.refModalMensaje.instance.showNotas = false;
    this.refModalMensaje.instance.botones = [
      {
        texto: "Cerrar", accion: () => {
          this.refModalMensaje.instance.funCerrar();
        }
      },
      {
        texto: "Seguir comprando", accion: () => {
          this.navegar('fabricante/' + fabricante.slug);
        }
      }
      //{ texto: textoBotonCancelar, accion: funcionCancelar }

      /*      { texto: textoBotonConfirmar, accion: () => console.log('Botón OK presionado') },
           { texto: textoBotonCancelar, accion: () => console.log('Botón Cancelar presionado') } */
    ];
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  mostrarMensajeModal(titulo, mensaje) {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalMensajeComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = mensaje;
    this.refModalMensaje.instance.titulo = titulo;
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  mostrarMensajeOkPedido() {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalConfirmComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = "Se ha creado el pedido correctamente.";
    this.refModalMensaje.instance.titulo =  "Pedido creado";
    this.refModalMensaje.instance.showBotonCancelar = false;
    this.refModalMensaje.instance.showNotas = false;
    this.refModalMensaje.instance.botones = [
      {
        texto: "Aceptar", accion: () => {
          this.navegar('buscador');
        }
      }
      //{ texto: textoBotonCancelar, accion: funcionCancelar }

      /*      { texto: textoBotonConfirmar, accion: () => console.log('Botón OK presionado') },
           { texto: textoBotonCancelar, accion: () => console.log('Botón Cancelar presionado') } */
    ];
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  navegar(direccion) {
    this.router.navigate([direccion]);
  }


  toggleDetallesPedido() {
    this.showDetallesPedido = !this.showDetallesPedido;
  }

  actualizarUser(direccionEntrega: any) {
   
    this.direccionEntrega= direccionEntrega;
    
    setTimeout(() => {
      if(this.direccionEntrega.provincia != null){
      this.onProvinciaChange({ value: this.direccionEntrega.provincia.id });
      }
      if(this.direccionEntrega.municipio != null){
        this.onMunicipioChange({ value: this.direccionEntrega.municipio.id });
      }
    }, 500);

  }

  iniciarSesion() {
    this.router.navigate(['login'], { queryParams: { returnUrl: "carrito" } });
  }

  getDatosFormulario() {
    this.mapService.getProvincias().subscribe((provincias) => {
      provincias.unshift({ id: "", text: "" });
      this.provincias = provincias;
      let userProvincia = JSON.parse(JSON.stringify(this.direccionEntrega.municipio));

      if (userProvincia != null) {
        this.valueProvincia = JSON.parse(JSON.stringify(this.direccionEntrega.municipio.provincia.id));
      }

    });

    this.mapService.getMunicipios().subscribe((municipios) => {
      municipios.unshift({ id: '', text: "" });
      this.municipios = municipios;

      if(this.user == null){
        this.cargarDatosDireccionEntregaCarrito();
      }

      /*if (this.user.municipio != null) {
        if (this.user.municipio.provincia.id != undefined && this.user.municipio.provincia.id != null && this.user.municipio.provincia.id != 0) {
          this.onProvinciaChange({ value: this.user.municipio.provincia.id });
          this.valueMunicipio = JSON.parse(JSON.stringify(this.user.municipio.id));
        }
      }*/

    });
  }

  cargarDatosDireccionEntregaCarrito() {
    const direccionEntregaCarrito = JSON.parse(localStorage.getItem('direccionEntregaCarrito'));

    if(direccionEntregaCarrito){
      this.direccionEntrega = direccionEntregaCarrito;

      this.direccionEntrega.politicas = false;
      this.direccionEntrega.novedades_registro = false;

      setTimeout(() => {
        this.onProvinciaChange({ value: this.direccionEntrega.municipio.provincia.id });
        this.onMunicipioChange({ value: this.direccionEntrega.municipio.id });
      }, 500);
    }
  }

  onProvinciaChange(value) {

    if (value != undefined && value.value != "") {

      let nombreProvincia = this.getNombreProvincia(value.value);
      let regionId = this.getRegionId(value.value);

      if (this.direccionEntrega.municipio == null) {

        this.direccionEntrega.municipio = {
          id: "",
          provincia: {
            id: value.value,
            nombre: nombreProvincia,
            text: nombreProvincia,
            id_region: regionId
          }
        };
      } else {
        this.direccionEntrega.municipio.provincia.id = value.value;
        this.direccionEntrega.municipio.provincia.nombre = nombreProvincia;
        this.direccionEntrega.municipio.provincia.text = nombreProvincia;
        this.direccionEntrega.municipio.provincia.id_region = regionId;
      }

      this.valueProvincia = value.value;
    } else {
      if (this.direccionEntrega.municipio == null) {
        this.direccionEntrega.municipio = {
          id: "",
          provincia: {
            id: null,
            nombre: "",
            text: ""
          }
        };
      } else {
        this.direccionEntrega.municipio.provincia.id = this.valueProvincia;
        this.direccionEntrega.municipio.provincia.nombre = "";
        this.direccionEntrega.municipio.provincia.text = "";
      }

    }

    if (this.municipios != undefined) {
      this.filteredMunicipios = this.municipios.filter(
        (municipio) => +municipio.id_provincia === +value.value
      );

      this.filteredMunicipios.unshift({ id: '', text: "" });

    }

  }

  getNombreProvincia(id) {
    for (let provincia of this.provincias) {
      if (provincia.id == id) {
        return provincia.nombre;
      }
    }
  }

  getRegionId(id) {
    for (let provincia of this.provincias) {
      if (provincia.id == id) {
        return provincia.id_region;
      }
    }
  }

  getNombreMunicipio(id) {
    for (let municipio of this.municipios) {
      if (municipio.id == id) {
        return municipio.nombre;
      }
    }
  }

  onMunicipioChange(value) {
    let nombreMunicipio = this.getNombreMunicipio(value.value);
    this.direccionEntrega.municipio.id = value.value;
    this.direccionEntrega.municipio.nombre = nombreMunicipio;
    this.direccionEntrega.municipio.text = nombreMunicipio;
   

    if(value.value != "" && value.value != null && value.value != undefined){
      this.municipioValido = true;
      this.valueMunicipio = value.value;
    }else{
      this.municipioValido = false;
    }

    this.calcularTotal();
    this.calcularGastoEnvio();
  }

  convertirSaltosDeLinea(texto) {
    return texto.replace(/\r\n|\r|\n/g, '<br>');
  }

  seleccionarRango(rango) {
    this.rangosSeleccionado = rango;
    this.calcularGastoEnvio();
  }

  calcularGastoEnvio() {

      this.gastoEnvio = 0;
      this.gastoEnvioMarcar = [];
      this.infoDescuentos = [];
      this.descuentoTotal = 0;
      for (const key in this.carrito) {
        if (this.carrito.hasOwnProperty(key)) {

          const marca = this.carrito[key];

          let precioEnvio = 0;
          let idZona = 0;

          if(this.direccionEntrega.municipio.id !='' &&
            this.direccionEntrega.municipio.id !=null &&
            this.direccionEntrega.municipio.id !=undefined){

              if(marca.fabricante.id_municipio == this.direccionEntrega.municipio.id){
                idZona = 1;
                marca.fabricante.responsable_envio = marca.fabricante.responsable_envio_municipio;

              }else if(marca.fabricante.id_provincia == this.direccionEntrega.municipio.provincia.id){
                idZona = 1;
                marca.fabricante.responsable_envio = marca.fabricante.responsable_envio_provincia;
              }else if(marca.fabricante.provincia.id_region == this.direccionEntrega.municipio.provincia.id_region){
                idZona = 2;
                marca.fabricante.responsable_envio = marca.fabricante.responsable_envio_comunidad_autonoma;
              }else{
                idZona = 3;
                marca.fabricante.responsable_envio = marca.fabricante.responsable_envio_pais;
              }
            }else{
              idZona = 1;
              marca.fabricante.responsable_envio = marca.fabricante.responsable_envio_municipio;
            }

              if(marca.fabricante.responsable_envio == "empresa"){
                precioEnvio = this.obtenerPrecioEnvio(idZona);
                marca.fabricante.hora_limite_recogida = marca.fabricante.hora_limite_recogida_empresa;
                marca.fabricante.dias_semana_sin_recogida = marca.fabricante.dias_semana_sin_recogida_empresa;
              }else if(marca.fabricante.responsable_envio == "propio"){
                precioEnvio = 0;
                marca.fabricante.hora_limite_recogida = marca.fabricante.hora_limite_recogida_propio;
                marca.fabricante.dias_semana_sin_recogida = marca.fabricante.dias_semana_sin_recogida_propio;
              }

              if(this.gastoEnvio == -1){
                this.gastoEnvio = precioEnvio;
              }else{
                this.gastoEnvio += precioEnvio;
              }
              
              this.gastoEnvioMarcar[key] = precioEnvio;

              if(idZona == 1 && marca.fabricante.responsable_envio == "empresa"){
                this.calcularDescuentos(key);
              }

              this.getHorarioEnvio(marca.fabricante);
          
          
        }
      }

      this.totalPedido = parseFloat(this.total.toString()) + (parseFloat(this.gastoEnvio.toString()) - this.descuentoTotal);
  }

  getHorarioEnvio(fabricante) {
    let diaSemana = new Date().getDay();
    for(let mensaje of fabricante.mensajes_entrega) {
      if(mensaje.dia_semana == diaSemana) {
        if(fabricante.responsable_envio == mensaje.tipo) {
          if(this.esAntesDeHoraLimite(fabricante)) {
            fabricante.horario_envio = mensaje.mensaje_antes_limite;
          }else{
            fabricante.horario_envio = mensaje.mensaje_despues_limite;
          }
        }
      }
    }
  }

  obtenerPrecioEnvio(id_zona) {
    let pesoMaximoTodo=0;
    this.sobrepeso = false;
    for (const tipoEnvio of this.logistica.tipo_envio) {
      if (tipoEnvio.id == this.rangosSeleccionado) {

        for (const precio of tipoEnvio.precios) {

          if (precio.id_zona == id_zona) {

            if(precio.peso_max > pesoMaximoTodo){
              pesoMaximoTodo = precio.peso_max;
            }

            if (this.pesoTotalPedido > precio.peso_min && this.pesoTotalPedido <= precio.peso_max) {
              this.sobrepeso = false;
              return precio.precio;
            }
          }
        }
      }
    }

    if(pesoMaximoTodo > 0 && (pesoMaximoTodo < this.pesoTotalPedido)){
      this.sobrepeso = true;
      this.mostrarMensajeModal("Sobrepeso", "El peso total del pedido es mayor al peso máximo permitido para el rango de envio seleccionado.");
    }

    return 0;
  }

  formatNumber(value: number | string | null | undefined): string {
    
    // Validar entrada
  if (value === null || value === undefined || value === '') {
    return '0,00';
  }

  let numero: number;
  
  // Convertir a número si es string
  if (typeof value === 'string') {
    // Limpiar el string y convertir comas a puntos para parseFloat
    const valorLimpio = value.toString().replace(/[^\d.,-]/g, '').replace(',', '.');
    numero = parseFloat(valorLimpio);
  } else {
    numero = Number(value);
  }

  // Verificar si es un número válido
  if (isNaN(numero)) {
    console.warn(`Valor inválido para formatNumber: ${value}`);
    return '0,00';
  }

  // Formatear con configuración española
  return numero.toLocaleString('es-ES', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
  }

  esAntesDeHoraLimite(fabricante): boolean {
    if (fabricante.hora_limite_recogida == null) {
      return false; // Si no hay hora límite, retornar false por defecto
    }
  
    const ahora = new Date();
    const horaLimite = fabricante.hora_limite_recogida;
    
    // Parsear la hora límite (formato "HH:mm")
    const [horaLimiteStr, minutoLimiteStr] = horaLimite.split(':');
    const horaLimiteNum = parseInt(horaLimiteStr, 10);
    const minutoLimiteNum = parseInt(minutoLimiteStr || '0', 10);
    
    // Crear fecha de referencia con la hora límite del día de hoy
    const horaReferencia = new Date();
    horaReferencia.setHours(horaLimiteNum, minutoLimiteNum, 0, 0);
    
    // Comparar timestamps
    return ahora.getTime() <= horaReferencia.getTime();
  }

}
